import { useEffect } from 'react';
import { hasCommandKey, isEditingText } from '../UndoRedo/keyboard';
import useMapActions from './useMapActions';

// Ctrl/Cmd+C copies the selected nodes, +V pastes them a step further, +D duplicates them (D-037).
// Text being edited keeps these keys. Renders nothing.
const MapShortcuts = ({ disabled }) => {
    const { copy, paste, duplicate, selectedIds, canPaste } = useMapActions();

    useEffect(() => {
        if (disabled) return undefined;
        const handleKeyDown = (event) => {
            if (!hasCommandKey(event) || event.shiftKey || isEditingText(event.target)) return;
            const key = event.key.toLowerCase();
            const ids = selectedIds();
            // Only take the key when there is something to act on, so normal copy/paste elsewhere still works.
            if (key === 'c' && ids.length > 0) copy(ids);
            else if (key === 'v' && canPaste) paste();
            else if (key === 'd' && ids.length > 0) duplicate(ids);
            else return;
            event.preventDefault();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [disabled, copy, paste, duplicate, selectedIds, canPaste]);

    return null;
};

export default MapShortcuts;
